import moment from 'moment-timezone';

export function generateTimeZoneOptions() {
    const majorCities = [
        'UTC',                // UTC±00
        'Pacific/Pago_Pago',  // UTC-11
        'Pacific/Honolulu',   // UTC-10
        'America/Anchorage',  // UTC-09
        'America/Los_Angeles', // UTC-08
        'America/Denver',     // UTC-07
        'America/Chicago',    // UTC-06
        'America/New_York',   // UTC-05
        'America/Santiago',   // UTC-04
        'America/Argentina/Buenos_Aires', // UTC-03
        'America/Noronha',    // UTC-02
        'Atlantic/Azores',    // UTC-01
        'Europe/London',      // UTC+00
        'Europe/Paris',       // UTC+01
        'Europe/Athens',      // UTC+02
        'Europe/Moscow',      // UTC+03
        'Asia/Dubai',         // UTC+04
        'Asia/Karachi',       // UTC+05
        'Asia/Dhaka',         // UTC+06
        'Asia/Bangkok',       // UTC+07
        'Asia/Shanghai',      // UTC+08
        'Asia/Tokyo',         // UTC+09
        'Australia/Sydney',   // UTC+10
        'Pacific/Noumea',     // UTC+11
        'Pacific/Auckland'    // UTC+12
    ];

    const seenOffsets = new Set();
    return majorCities.map(city => {
        const now = moment.tz(city);
        const offsetInMinutes = now.utcOffset();
        const sign = offsetInMinutes >= 0 ? "+" : "-";
        const hours = String(Math.floor(Math.abs(offsetInMinutes) / 60)).padStart(2, '0');
        const minutes = String(Math.abs(offsetInMinutes) % 60).padStart(2, '0');
        const offset = `UTC${sign}${hours}:${minutes}`;

        if (!seenOffsets.has(offset)) {
            seenOffsets.add(offset);
            const label = `${offset} (${city})`;
            return (
                <option key={city} value={city}>
                    {label}
                </option>
            );
        }
        return null;
    }).filter(Boolean);
}

export function dateText(selectedInit, timeZone, fhour, setInitstr, setTiming, setValidstr) {
    if (selectedInit) {
        const selectedTimeZone = timeZone || 'UTC';
        const initdate = moment.utc(selectedInit, 'YYYYMMDD_HH').tz(selectedTimeZone);
        const initdatestr = initdate.format('MM-DD-YYYY HH:mm [Z]');
        const validdate = moment.utc(selectedInit, 'YYYYMMDD_HH').add(parseInt(fhour, 10), 'hours').tz(selectedTimeZone);
        const validdatestr = validdate.format('MM-DD-YYYY HH:mm [Z]');
        setInitstr(initdatestr);
        setTiming("F" + fhour);
        setValidstr(validdatestr);
    }
}

export async function initializations(setInitializationOptions, setSelectedInit, prevSelectedInitRef) {
        const response = await fetch(`${window.location.origin}/geojsons/subdirectories.json`);
        if (!response.ok) {
            throw new Error("Failed to fetch subdirectory data.");
        }

        const data = await response.json();
        const subdirectories = data.subdirectories;

        if (!subdirectories || subdirectories.length === 0) {
            throw new Error("No valid subdirectories found.");
        }

        const mostRecentDir = subdirectories[0];
        const year = mostRecentDir.slice(0, 4);   // Extract YYYY
        const month = mostRecentDir.slice(4, 6); // Extract mm
        const day = mostRecentDir.slice(6, 8);   // Extract dd
        const hour = mostRecentDir.slice(9, 11); // Extract HH
        const newInitOptions = [];
        const newdate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour)));

        for (let n = 3; n >= 0; n--) {
            const olddate = new Date(newdate);
            olddate.setHours(olddate.getHours() - 12 * n);

            const oldyear = olddate.getUTCFullYear();
            const oldmonth = String(olddate.getUTCMonth() + 1).padStart(2, '0');
            const oldday = String(olddate.getUTCDate()).padStart(2, '0');
            const oldhour = String(olddate.getUTCHours()).padStart(2, '0');

            const olddatefilefmt = `${oldyear}${oldmonth}${oldday}_${oldhour}`;
            const olddatestr = `${oldmonth}-${oldday}-${oldyear} ${oldhour}Z`;
            newInitOptions.push({ value: olddatefilefmt, label: olddatestr });
        }

        setInitializationOptions(newInitOptions.reverse());
        setSelectedInit(newInitOptions[0].value); // Set default selected init
        prevSelectedInitRef.current = newInitOptions[0].value;
}

export function initFhourAdjust({
    selectedModel,
    selectedInit,
    fhour,
    setFhour,
    prevSelectedInitRef
}) {
    const prevInitDate = moment(prevSelectedInitRef.current, 'YYYYMMDD_HH');
    const fhourInt = parseInt(fhour, 10);
    const validTime = prevInitDate.add(fhourInt, 'hours');
    const newInitDate = moment(selectedInit, 'YYYYMMDD_HH');
    const newFhour = validTime.diff(newInitDate, 'hours');
    const calculatedFhour = newFhour < 0 ? "000" : (newFhour > 240 ? "240" : String(newFhour).padStart(3, '0'));
    setFhour(calculatedFhour);
    prevSelectedInitRef.current = selectedInit;
}